const panLabel = ({ pan, name, status }) => {
  const base = name ? `${name} · ${pan}` : pan;
  return status === 'deactivated' ? `${base} (deactivated)` : base;
};

const PanSelect = ({ pans, value, onChange }) => (
  <select
    className="form-select form-select-sm w-auto"
    aria-label="Filter by PAN"
    value={value}
    onChange={(event) => onChange(event.target.value)}
  >
    <option value="">All PANs</option>
    {pans.map((entry) => (
      <option key={entry.pan} value={entry.pan}>
        {panLabel(entry)}
      </option>
    ))}
  </select>
);

export default PanSelect;
